import { render, staticRenderFns } from "./PermisosList.vue?vue&type=template&id=5d67e9e6&scoped=true&"
import script from "./PermisosList.vue?vue&type=script&lang=js&"
export * from "./PermisosList.vue?vue&type=script&lang=js&"
import style0 from "./PermisosList.vue?vue&type=style&index=0&id=5d67e9e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d67e9e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCheckbox,VCol,VRow,VSimpleTable})
